// extracted by mini-css-extract-plugin
module.exports = {"info_box":"info_box-2LXlF5I4 clearfix","comment":"comment-LrO_9RKY","pic":"pic-3xFNYP6N","v_logo":"v_logo-Z1lWjW8G","text":"text-3S1HLdfZ","time":"time-1t-S-1AN"};